import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { ContrastSection } from '../components/ContrastSection';
import { StickyCTA } from '../components/StickyCTA';
/* Lazy-load only truly below-fold sections to reduce network waterfall.
   Grouped into two Suspense boundaries to minimize chunk requests. */
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-447">
      {/* Above-fold: eagerly loaded for fastest FCP/LCP */}
      <HeroSection data-id="element-448" />
      <TrustBar data-id="element-449" />
      <ContrastSection data-id="element-450" />

      {/* Near-fold: lazy but grouped */}
      <Suspense fallback={null} data-id="element-451">
        <ForWhomSection data-id="element-452" />
        <BenefitsSection data-id="element-453" />
        <ContentPreview data-id="element-454" />
        <BonusSection data-id="element-455" />
        <PricingSection data-id="element-456" />
      </Suspense>

      {/* Far below fold */}
      <Suspense fallback={null} data-id="element-457">
        <GuaranteeSection data-id="element-458" />
        <TestimonialsSection data-id="element-459" />
        <ExpertSection data-id="element-460" />
        <FAQSection data-id="element-461" />
        <Footer data-id="element-462" />
        <SocialProofPopup data-id="element-463" />
      </Suspense>

      <StickyCTA data-id="element-464" />
    </main>;
}